import {
    MixedItem,
    RBChannel,
    RBProgram,
    SearchProgram,
} from 'store/railsBuilder/reducer.types';
import { RecordingItem } from 'store/recordings/reducer.types';

import {
    CdvrRecording,
    ContentType,
    NowNextData,
} from 'services/data-manager/types';

import createEmptyItem, {
    EmptyCollectionItem,
} from 'screens/Collection/utils/createEmptyItem';

import { CollectionItemsList, ColumnsCollectionItemsList } from '../types';

function prepareCollectionList(
    numberOfColumns: number,
    originalList: CollectionItemsList,
    type: ContentType | undefined,
): ColumnsCollectionItemsList {
    if (!originalList || !type) {
        return [];
    }

    if (numberOfColumns > 1 && originalList.length % numberOfColumns !== 0) {
        const collectionItems = [...originalList];
        const limit =
            numberOfColumns - (collectionItems.length % numberOfColumns);

        for (let i = 0; i < limit; i += 1) {
            // @ts-ignore
            collectionItems.push(createEmptyItem(type));
        }

        return collectionItems as
            | (RecordingItem | EmptyCollectionItem)[]
            | (MixedItem | EmptyCollectionItem)[]
            | (NowNextData | EmptyCollectionItem)[]
            | (RBChannel | EmptyCollectionItem)[]
            | (RBProgram | EmptyCollectionItem)[]
            | (SearchProgram | EmptyCollectionItem)[]
            | (RecordingItem | EmptyCollectionItem)[]
            | (CdvrRecording | EmptyCollectionItem)[];
    }

    return originalList;
}

export default prepareCollectionList;
